import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { AdminAuthProvider } from './contexts/AdminAuthContext'
import ChatPage from './pages/ChatPage'
import AdminLoginPage from './pages/AdminLoginPage'
import AdminDashboardPage from './pages/AdminDashboardPage'
import './App.css'

// Single AdminAuthProvider shared across all /admin/* routes so that
// login state persists when navigating between /admin/login and /admin/.
function AdminLayout() {
  return (
    <AdminAuthProvider>
      <Outlet />
    </AdminAuthProvider>
  )
}

function AppRoutes() {
  const { isReady } = useAuth()
  const { pathname } = useLocation()

  // Admin routes use Cognito — they don't receive a postMessage token.
  // When auth is enabled, hold rendering until the parent app sends the token.
  // In local dev (VITE_ENABLE_AUTH=false) isReady is always true.
  if (!isReady && !pathname.startsWith('/admin')) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
        color: '#666',
      }}>
        Connecting...
      </div>
    )
  }

  return (
    <Routes>
      {/* Chatbot */}
      <Route path="/" element={<ChatPage />} />
      <Route path="/chat/:conversationId?" element={<ChatPage />} />

      {/* Admin — all routes share one AdminAuthProvider so login state persists */}
      <Route element={<AdminLayout />}>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/*"     element={<AdminDashboardPage />} />
      </Route>
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  )
}

export default App
